import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { clDeliveredOrderLineStatusLookupId, qaCompletedOrderLineStatusLookupId } from '../QaOrderReview/constants';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import { ReturnOrderDialog } from '../ReturnOrderDialog';
import { MenuItem } from '@material-ui/core';

const styles = theme => ({
  rejectButton: {
    marginRight: '8px',
    backgroundColor: '#f44336',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
    rejectButtonFocused: {
      backgroundColor: '#d2190b',
    },
  },
});

const propTypes = {
  classes: PropTypes.object.isRequired,
};

export const ReturnOrderButton = withRouter(
  withStyles(styles)(({ classes, orderLineId, onClose }) => {
    const { state } = useContext(OrderReviewContext);
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDialogOpen = () => {
      setDialogOpen(true);
    };

    return (
      <React.Fragment>
        <MenuItem
          onClick={handleDialogOpen}
          disabled={
            state.orderLineStatusLookupId !== qaCompletedOrderLineStatusLookupId &&
            state.orderLineStatusLookupId !== clDeliveredOrderLineStatusLookupId
              ? false
              : true
          }
        >
          Return Order
        </MenuItem>

        <ReturnOrderDialog
          //
          orderLineId={orderLineId}
          open={dialogOpen}
          setOpen={setDialogOpen}
          onClose={onClose}
        />
      </React.Fragment>
    );
  }),
);

ReturnOrderButton.propTypes = propTypes;
ReturnOrderButton.defaultProps = {};
